import store from "@/store"

export default {
    get resubmitRoute() {
        return store.state.validation.data.resubmitRoute
    },

    set resubmitRoute(route) {
        store.commit("validation/setResubmitRoute", route)
    },

    get invalidApplicants() {
        return store.state.validation.data.invalidApplicants
    },

    set invalidApplicants(applicants) {
        store.commit("validation/setInvalidApplicants", applicants)
    },

    get validationErrorResponse() {
        return store.state.validation.data.validationErrorResponse
    },

    set validationErrorResponse(response) {
        store.commit("validation/setValidationErrorResponse", response)
    },
}
